import React, { useContext, useEffect, useState } from 'react'
import { FaWandMagicSparkles } from 'react-icons/fa6';
import { SelectionContext } from '../../../Context/Store';
import logo from '../../../assets/svg/logo-dashboard-v1.png';
import { Link, useLocation } from 'react-router-dom';
import { RiDashboard2Line } from "react-icons/ri";
import { BiCategoryAlt, BiNotification, BiSolidAnalyse, BiSolidRegistered, BiStore, BiTask } from "react-icons/bi";
import { FiAward, FiBarChart2, FiBell, FiBriefcase, FiChevronRight, FiCreditCard, FiDownload, FiGrid, FiHeadphones, FiHome, FiImage, FiMap, FiMenu, FiPackage, FiSettings, FiShoppingBag, FiTag, FiTruck, FiUserCheck, FiUserPlus, FiX } from "react-icons/fi";
import { MdPrecisionManufacturing, MdStore } from "react-icons/md";
import { FaTasks, FaUsers } from 'react-icons/fa';
import { CiShoppingCart } from 'react-icons/ci';
import { IoHomeOutline } from "react-icons/io5";
import { BsDatabaseAdd, BsHandbag } from "react-icons/bs";
import { RiBarChartBoxLine } from "react-icons/ri";
import { PiCreditCard } from "react-icons/pi";
import { TbAnalyze, TbDiscount2, TbFileAnalytics } from "react-icons/tb";
import { BiSupport } from "react-icons/bi";
import { IoSettingsOutline } from "react-icons/io5";
import logowrap from '../../../assets/images/Adidas-logo.png';
import { MdKeyboardArrowRight } from "react-icons/md";
import logogetto from '../../../assets/svg/logo-dashboard-v1.png'
import { checkUserPermissions } from '../../../helpers/permission';
import { getStoresListing } from '../../../api/context/manufacturer';
import { updateDetailsState } from '../../../atoms/updateDetails';
import { useRecoilState } from 'recoil';
import { FaImage } from "react-icons/fa";
import { MdOutlineBrandingWatermark } from "react-icons/md";
import { MdOutlineSupportAgent, MdOutlineChat } from "react-icons/md";
import { FaGear, FaMotorcycle, FaRegImage, FaStore } from 'react-icons/fa6';



const SIDEBAR_WIDTH = 200;
const SIDEBAR_STYLES = {
    navItem:         { marginBottom: '1px' },
    navSubItem:      { marginBottom: '0' },
    subNavLink:      { fontSize: '11px', padding: '5px 12px 5px 40px', color: '#6b7280' },
    profileWrap:     { padding: '8px 10px', margin: '0 10px 8px', gap: '8px', borderRadius: '10px' },
    profileImg:      { width: '30px', height: '30px' },
    profileName:     { fontSize: '11px', fontWeight: 600, marginBottom: '1px', lineHeight: 1.2 },
    profileEmail:    { fontSize: '10px', color: '#6b7280', lineHeight: 1.2, marginBottom: 0 },
    aiWrap:          { padding: '8px 10px', margin: '0 10px 6px', gap: '8px', borderRadius: '10px' },
    aiIcon:          { width: '26px', height: '26px', fontSize: '12px', borderRadius: '7px' },
    aiTitle:         { fontSize: '11px', fontWeight: 600, lineHeight: 1.2 },
    aiSub:           { fontSize: '10px', color: '#6b7280', lineHeight: 1.2 },
};

const Sidebar = () => {

    const location = useLocation();
    const user = JSON.parse(localStorage.getItem('user'));
    const [refresh] = useRecoilState(updateDetailsState);
    const [store, setStore] = useState([]);
    const [drawerOpen, setDrawerOpen] = useState(false);

    const isVendor = user?.userType === 'Vendor';
    const { billingBalance, refreshBillingBalance, updateCount } = useContext(SelectionContext);
    const subscriptionPlanName = billingBalance?.subscription?.planName;

    // Close drawer when navigating (any pathname change)
    useEffect(() => { setDrawerOpen(false); }, [location.pathname]);
    // Close drawer on window resize to desktop width
    useEffect(() => {
        const onResize = () => {
            if (window.innerWidth > 767) setDrawerOpen(false);
        };
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);
    // Lock body scroll while drawer is open
    useEffect(() => {
        const original = document.body.style.overflow;
        document.body.style.overflow = drawerOpen ? 'hidden' : original || '';
        return () => { document.body.style.overflow = original; };
    }, [drawerOpen]);

    useEffect(() => {
        if (isVendor) refreshBillingBalance();
    }, [isVendor, refreshBillingBalance]);

    // ===== PWA install prompt =====
    const [installPrompt, setInstallPrompt] = useState(null);
    const [isStandalone, setIsStandalone] = useState(false);

    useEffect(() => {
        const standalone = window.matchMedia && window.matchMedia('(display-mode: standalone)').matches;
        const iosStandalone = typeof window.navigator?.standalone === 'boolean' && window.navigator.standalone;
        setIsStandalone(Boolean(standalone || iosStandalone));

        const onBeforeInstall = (e) => {
            e.preventDefault();
            setInstallPrompt(e);
        };
        const onInstalled = () => {
            setInstallPrompt(null);
            setIsStandalone(true);
        };
        window.addEventListener('beforeinstallprompt', onBeforeInstall);
        window.addEventListener('appinstalled', onInstalled);
        return () => {
            window.removeEventListener('beforeinstallprompt', onBeforeInstall);
            window.removeEventListener('appinstalled', onInstalled);
        };
    }, []);

    const isIOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const canShowInstall = !isStandalone && (installPrompt || isIOS);

    const handleInstallApp = async () => {
        if (installPrompt) {
            try {
                installPrompt.prompt();
                const { outcome } = await installPrompt.userChoice;
                if (outcome === 'accepted') setInstallPrompt(null);
            } catch (err) {
                console.error('Install prompt failed', err);
            }
        } else if (isIOS) {
            alert('To install Getto on iOS:\n\n1. Tap the Share button in Safari\n2. Scroll down and tap "Add to Home Screen"\n3. Tap "Add" to confirm');
        }
    };

    const getStoresDetails = () => {
        getStoresListing()((response) => {
            if (response?.statusCode == 200) {
                setStore(response?.data?.[0]);
            } else {
            }
        });
    };

    useEffect(() => {
        getStoresDetails()
    }, [refresh]);

    const userType = JSON.parse(localStorage.getItem('user'))?.userType;

    return (
        <>
        <style>{`
          :root { --vz-vertical-menu-width: ${SIDEBAR_WIDTH}px; }

          .app-menu {
            box-shadow: none !important;
            border-right: 1px solid #e5e7eb;
            display: flex;
            flex-direction: column;
            height: 100vh;
            overflow: hidden !important;
            background-color: #f9fafb !important;
            width: ${SIDEBAR_WIDTH}px !important;
          }
          .app-menu > div:first-of-type {
            display: flex; flex-direction: column;
            flex: 1 1 auto; min-height: 0; overflow: hidden;
          }
          .app-menu .navbar-brand-box {
            flex-shrink: 0;
            padding: 14px 12px !important;
            min-height: auto; height: auto;
            border-bottom: 1px solid #e5e7eb;
          }
          .app-menu .navbar-brand-box .logo {
            display: flex !important;
            align-items: center;
            justify-content: center;
            padding: 0 !important;
            margin: 0 !important;
            line-height: 0 !important;
            width: 100%;
          }
          .app-menu .navbar-brand-box .logo-sm { display: none !important; }
          .app-menu .navbar-brand-box .logo-lg {
            display: flex !important;
            align-items: center;
            justify-content: center;
            padding: 0 !important;
            margin: 0 !important;
            line-height: 0 !important;
          }
          .app-menu .navbar-brand-box .logo img {
            max-height: 42px !important; width: auto !important;
            display: block !important;
            margin: 0 auto !important;
            padding: 0 !important;
          }
          .app-menu #scrollbar { flex: 1 1 auto; overflow-y: auto; min-height: 0; }
          .app-menu .bottom_wrapper_sidebar { flex-shrink: 0; }

          .app-menu *, .app-menu { scrollbar-width: none; -ms-overflow-style: none; }
          .app-menu *::-webkit-scrollbar, .app-menu::-webkit-scrollbar {
            width: 0 !important; height: 0 !important; display: none !important;
          }
          .app-menu .simplebar-track, .app-menu .simplebar-scrollbar { display: none !important; }

          .app-menu .navbar-nav { padding: 4px 6px !important; }
          .app-menu .navbar-nav > .nav-item { margin-bottom: 1px !important; }
          .app-menu .navbar-nav > .nav-item > .nav-link.menu-link {
            font-size: 11px !important;
            font-weight: 500 !important;
            padding: 10px 14px !important;
            gap: 9px !important;
            border-radius: 8px !important;
            line-height: 1.2 !important;
          }
          @media (min-width: 768px) {
            .app-menu .navbar-nav > .nav-item > .nav-link.menu-link.active {
              padding: 12px 14px !important;
              border-radius: 4px !important;
            }
          }
          /* Install app button — inherits the .menu-link look but is a native <button> */
          .app-menu .install-app-link {
            width: 100%;
            text-align: left;
            background: transparent;
            border: none;
            appearance: none;
            font-family: inherit;
            cursor: pointer;
          }
          .app-menu .navbar-nav .nav-link { display: flex; align-items: center; gap: 7px; }
          .app-menu .navbar-nav .nav-link > svg {
            width: 13px !important; height: 13px !important; flex-shrink: 0;
          }
          .app-menu .nav-sm .nav-link {
            font-size: 10.5px !important;
            padding: 7px 16px 7px 38px !important;
          }

          .app-menu .bottom_wrapper_sidebar {
            padding: 8px 10px !important;
            margin: 0 10px 8px !important;
            gap: 8px !important;
            border-radius: 10px !important;
          }
          .app-menu .bottom_wrapper_sidebar .user_pro_wrapper { gap: 8px !important; }
          .app-menu .bottom_wrapper_sidebar .img_wrapper {
            width: 30px !important; height: 30px !important;
          }
          .app-menu .bottom_wrapper_sidebar .content_wrapper h5 {
            font-size: 11px !important; margin-bottom: 1px !important; line-height: 1.2 !important;
          }
          .app-menu .bottom_wrapper_sidebar .content_wrapper p {
            font-size: 10px !important; line-height: 1.2 !important;
          }

          .app-menu .bottom_wrapper_ai {
            padding: 8px 10px !important;
            margin: 0 10px 6px !important;
            gap: 8px !important;
            border-radius: 10px !important;
          }
          .app-menu .bottom_wrapper_ai .ai-widget-icon {
            width: 26px !important; height: 26px !important;
            font-size: 12px !important; border-radius: 7px !important;
          }
          .app-menu .bottom_wrapper_ai .ai-widget-title {
            font-size: 11px !important; line-height: 1.2 !important;
          }
          .app-menu .bottom_wrapper_ai .ai-widget-sub {
            font-size: 10px !important; line-height: 1.2 !important;
          }
          .app-menu .bottom_wrapper_ai .ai-widget-count {
            font-size: 10px !important; min-width: 22px !important; padding: 0 6px !important;
          }
          /* Active state — teal fill when on /billing or /billing/history */
          .app-menu .bottom_wrapper_ai.active {
            background: #008695 !important;
            border-color: #008695 !important;
            color: #fff !important;
            box-shadow: 0 4px 12px rgba(0, 134, 149, 0.25);
          }
          .app-menu .bottom_wrapper_ai.active:hover {
            background: #006672 !important;
            border-color: #006672 !important;
            color: #fff !important;
          }
          .app-menu .bottom_wrapper_ai.active .ai-widget-icon {
            background: rgba(255, 255, 255, 0.22) !important;
            color: #fff !important;
          }
          .app-menu .bottom_wrapper_ai.active .ai-widget-title {
            color: #fff !important;
          }
          .app-menu .bottom_wrapper_ai.active .ai-widget-sub {
            color: rgba(255, 255, 255, 0.85) !important;
          }
          .app-menu .bottom_wrapper_ai.active .ai-widget-count {
            background: rgba(255, 255, 255, 0.22) !important;
            color: #fff !important;
          }

          .main-content { margin-left: ${SIDEBAR_WIDTH}px; }

          /* --- Mobile top-bar (fixed) + slide-in drawer --- */
          .mobile-topbar { display: none; }
          .mobile-drawer-close { display: none; }
          .mobile-overlay { display: none; }

          @media (max-width: 767.98px) {
            .mobile-topbar {
              display: flex;
              align-items: center;
              justify-content: space-between;
              position: fixed;
              top: 0; left: 0; right: 0;
              height: 52px;
              padding: 0 24px;
              background: #ffffff;
              border-bottom: 1px solid #e5e7eb;
              z-index: 1050;
            }
            .mobile-topbar-logo { max-height: 34px; width: auto; display: block; }
            .mobile-topbar-menu {
              width: 36px; height: 36px;
              display: inline-flex; align-items: center; justify-content: center;
              border: 1px solid #e5e7eb; background: #fff;
              border-radius: 6px; padding: 0;
              color: #0f172a; cursor: pointer;
            }
            .mobile-topbar-menu:hover { background: #f8fafc; }

            /* Sidebar becomes a fixed left slide-in drawer */
            .app-menu {
              position: fixed !important;
              top: 0 !important;
              left: 0 !important;
              bottom: auto !important;
              height: 100vh !important;
              width: 260px !important;
              transform: translateX(-100%);
              transition: transform 0.25s ease;
              z-index: 1052;
              display: flex !important;
              flex-direction: column !important;
              justify-content: flex-start !important;
              background-color: #ffffff !important;
              overflow: hidden !important;
            }
            .app-menu.drawer-open { transform: translateX(0); }
            .app-menu > div:first-of-type { padding-top: 8px; }

            /* Show brand + close button inside drawer */
            .app-menu .navbar-brand-box { display: flex !important; align-items: center; justify-content: space-between; padding: 6px 12px !important; border-bottom: 1px solid #e5e7eb; }
            .app-menu #vertical-hover { display: none !important; }
            .mobile-drawer-close {
              display: inline-flex; align-items: center; justify-content: center;
              width: 30px; height: 30px;
              border: 1px solid #e5e7eb; background: #fff;
              border-radius: 6px; padding: 0;
              color: #475569; cursor: pointer;
            }

            /* Restore nav-links to their normal (non-bottom-bar) rendering */
            .app-menu .navbar-nav { flex-direction: column !important; padding: 6px 8px !important; width: 100% !important; }
            .app-menu .navbar-nav > .nav-item { width: 100%; }
            .app-menu .navbar-nav > .nav-item > .nav-link.menu-link { padding: 12px 14px !important; }
            .app-menu .navbar-nav > .nav-item > .nav-link.menu-link span { display: inline !important; }
            .app-menu #sidebarUsers { display: block !important; }

            /* Show profile/AI wrappers again inside drawer */
            .app-menu .navbar-brand-box,
            .app-menu .bottom_wrapper_sidebar,
            .app-menu .bottom_wrapper_ai { display: flex !important; }
            .app-menu .sidebar-background { display: none !important; }

            /* Overlay */
            .mobile-overlay {
              display: block;
              position: fixed; inset: 0;
              background: rgba(15,23,42,0.45);
              z-index: 1051;
              opacity: 0;
              pointer-events: none;
              transition: opacity 0.2s ease;
            }
            .mobile-overlay.open { opacity: 1; pointer-events: auto; }

            /* Push main content down so the top-bar doesn't cover it — and kill page-content's 94px top padding since we manage spacing here */
            .main-content { margin-left: 0; padding-top: 52px; }
            .page-content { padding: 8px 12px 24px !important; }

            /* Internal pages with a back button: hide the mobile top-bar so the page's own header (with back button) is the effective header */
            body:has(.back-btn) .mobile-topbar { display: none !important; }
            body:has(.back-btn) .main-content { padding-top: 0 !important; }
            body:has(.back-btn) .page-header-sticky { top: 0 !important; }
          }
        `}</style>
        {/* Mobile top-bar (only visible on mobile) */}
        <div className="mobile-topbar">
            <Link to={`${userType === 'customerSupport' ? "/chat-support" : "/"}`}>
                <img src={logo} alt="Getto" className="mobile-topbar-logo" />
            </Link>
            <button
                type="button"
                className="mobile-topbar-menu"
                onClick={() => setDrawerOpen(true)}
                aria-label="Open menu"
            >
                <FiMenu size={18} />
            </button>
        </div>

        {/* Overlay for closing the drawer */}
        <div
            className={`mobile-overlay ${drawerOpen ? 'open' : ''}`}
            onClick={() => setDrawerOpen(false)}
        />

        <div className={`app-menu navbar-menu ${drawerOpen ? 'drawer-open' : ''}`}>
            <div>
                <div className="navbar-brand-box">
                    <Link to={`${userType === 'customerSupport' ? "/chat-support" : "/"}`} className="logo logo-dark">
                        <span className="logo-sm">
                            <img src={logo} alt="" height={22} />
                        </span>
                        <span className="logo-lg">
                            <img src={logo} alt="" className='logo_tabs' />
                        </span>
                    </Link>

                    <button
                        type="button"
                        className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
                        id="vertical-hover"
                    >
                        <i className="ri-record-circle-line" />
                    </button>

                    <button
                        type="button"
                        className="mobile-drawer-close"
                        onClick={() => setDrawerOpen(false)}
                        aria-label="Close menu"
                    >
                        <FiX size={16} />
                    </button>
                </div>
                <div id="scrollbar">
                    <div className="container-fluid p-0">
                        <div id="two-column-menu" />
                        <ul className="navbar-nav" id="navbar-nav">

                            {checkUserPermissions('view_orders') &&
                                (<li className={`nav-item ${location.pathname === '/' ? 'active' : ''}`}>
                                    <Link to={'/'} className="nav-link menu-link" >
                                        <FiHome /><span data-key="t-widgets">Dashboard</span>
                                    </Link>
                                </li>)
                            } 

                            {checkUserPermissions('view_orders') && user?.userType === 'ADMIN' ? (
                                <li className={`nav-item ${location.pathname === '/analytics-dashboard' || location.pathname === '/search-analytics' || location.pathname === '/promo-analytics' || location.pathname === '/location-analytics' || location.pathname === '/ai-listing-analytics' ? 'active' : ''}`}>
                                    <Link to={'/analytics-dashboard'} className="nav-link menu-link" >
                                        <FiBarChart2 /><span data-key="t-widgets">Analytics</span>
                                    </Link>
                                </li>
                            ) : null}


                            {checkUserPermissions('view_banners') ?
                                <li className={`nav-item ${location.pathname === '/banner' || location.pathname === '/create-banner' || /^\/edit-banner\/\d+$/.test(location.pathname) ? 'active' : ''}`}>
                                    <Link to={'/banner'} className="nav-link menu-link" >
                                        <FiImage /><span data-key="t-widgets">Banner</span>
                                    </Link>
                                </li>
                                :
                                <></>
                            }

                            {checkUserPermissions('view_banners') ?
                                <li className={`nav-item ${location.pathname === '/brand' || /^\/edit-brand-page\/\d+$/.test(location.pathname) ? 'active' : ''}`}>
                                    <Link to={'/brand'} className="nav-link menu-link" >
                                        <FiAward /><span data-key="t-widgets">Brand</span>
                                    </Link>
                                </li>
                                :
                                <></>
                            }

                            {checkUserPermissions('view_category') || checkUserPermissions('view_sub_category') ?
                                <li className={`nav-item ${location.pathname === '/categories' || location.pathname === '/create-sub-categories' || /^\/sub-categories\/\d+$/.test(location.pathname) || /^\/create-sub-categories\/\d+$/.test(location.pathname) ? 'active' : ''}`}>
                                    {checkUserPermissions('view_category') ?
                                        <Link to={'/categories'} className="nav-link menu-link" >
                                            <FiGrid /><span data-key="t-widgets">Categories</span>
                                        </Link>
                                        :
                                        <></>
                                    }
                                </li>
                                :
                                <></>
                            }

                            {checkUserPermissions('view_products') ?
                                <li className={`nav-item ${location.pathname === '/inventory' || location.pathname === '/create-inventory' || location.pathname === '/create-ai-inventory' || /^\/edit-inventory\/\d+$/.test(location.pathname) ? 'active' : ''}`}>
                                    <Link to={'/inventory'} className="nav-link menu-link" >
                                        <FiPackage /> <span data-key="t-widgets">Inventory</span>
                                    </Link>
                                </li>
                                :
                                <></>
                            }


                            {checkUserPermissions('view_promocodes') ?
                                <li className={`nav-item ${location.pathname === '/promocodes' ? 'active' : ''}`}>
                                    <Link to={'/promocodes'} className="nav-link menu-link" >
                                        <FiTag /> <span data-key="t-widgets">Promocodes</span>
                                    </Link>
                                </li>
                                :
                                <></>
                            }

                            {/* {checkUserPermissions('view_promocodes') ?
                                <li className={`nav-item ${location.pathname === '/promocodes-page' || location.pathname === '/create-promocodes' || /^\/edit-promocodes\/\d+$/.test(location.pathname) ? 'active' : ''}`}>
                                    <Link to={'/promocodes-page'} className="nav-link menu-link" >
                                        <FiTag /> <span data-key="t-widgets">Promocodes</span>
                                    </Link>
                                </li>
                                :
                                <></>
                            } */}

                            {checkUserPermissions('view_manufacturer') ?
                                <li className={`nav-item ${location.pathname === '/vendors' || location.pathname === '/sync-category' || /^\/sync-inventory\/\d+$/.test(location.pathname) || /^\/edit-vendors\/\d+$/.test(location.pathname) || /^\/sync-category\/\d+$/.test(location.pathname) || /^\/map-category-size\/\d+$/.test(location.pathname) ? 'active' : ''}`}>
                                    <Link to={'/vendors'} className="nav-link menu-link">
                                        <FiBriefcase /> <span data-key="t-widgets">Vendors</span>
                                    </Link>
                                </li>
                                :
                                <></>
                            }

                            {checkUserPermissions('view_orders') ?
                                <li className={`nav-item ${location.pathname === '/orders' || /^\/orderdetails\/\d+$/.test(location.pathname) ? 'active' : ''}`}>
                                    <Link to={'/orders'} className="nav-link menu-link" >
                                        <FiShoppingBag /><span data-key="t-widgets">Orders</span>
                                    </Link>
                                </li>
                                :
                                <></>
                            }

                            {checkUserPermissions('view_orders') && user?.userType === 'ADMIN' ? (
                                <li className={`nav-item ${location.pathname === '/tracking' ? 'active' : ''}`}>
                                    <Link to={'/tracking'} className="nav-link menu-link" >
                                        <FiMap /><span data-key="t-widgets">Tracking</span>
                                    </Link>
                                </li>
                            ) : null}

                            {checkUserPermissions('view_manufacturer') ?
                                <li className={`nav-item ${location.pathname === '/auto-notification' ? 'active' : ''}`}>
                                    <Link to={'/auto-notification'} className="nav-link menu-link">
                                        <FiBell /> <span data-key="t-widgets">Auto Notifications</span>
                                    </Link>
                                </li>
                                :
                                <></>
                            }

                            {checkUserPermissions('view_orders') && user?.userType === 'ADMIN' ? (
                                <li className={`nav-item ${location.pathname === '/admin-settings' ? 'active' : ''}`}>
                                    <Link to={'/admin-settings'} className="nav-link menu-link" >
                                        <FiSettings /><span data-key="t-widgets">Settings</span>
                                    </Link>
                                </li>
                            ) : null}

                            {checkUserPermissions('view_payments') ?
                                <li className={`nav-item ${location.pathname === '/payments' ? 'active' : ''}`}>
                                    <Link to={'/payments'} className="nav-link menu-link" >
                                        <FiCreditCard /><span data-key="t-widgets">Payments</span>
                                    </Link>
                                </li>
                                :
                                <></>
                            }



                            {user?.userType === 'customerSupport' ?
                                <li className={`nav-item ${location.pathname === '/chat-support' ? 'active' : ''}`}>
                                    <Link to={'/chat-support'} className="nav-link menu-link" >
                                        <FiHeadphones /><span data-key="t-widgets">Chat Support</span>
                                    </Link>
                                </li>
                                :
                                <></>
                            }

                            {(user?.userType !== 'customerSupport' && user?.userType !== 'ADMIN' && user?.userType !== 'Vendor') &&

                                <li className={`nav-item ${location.pathname === '/register-vendor' ? 'active' : ''}`}>
                                    <Link to={'/register-vendor'} className="nav-link menu-link" >
                                        <FiUserPlus /> <span data-key="t-widgets">Registration</span>
                                    </Link>
                                </li>
                            }


                            {(isVendor || user?.userType === 'ADMIN') && (
                                <li className={`nav-item ${location.pathname === '/view-notifications' ? 'active' : ''}`}>
                                    <Link to={'/view-notifications'} className="nav-link menu-link sidebar-notification-link">
                                        <FiBell />
                                        <span data-key="t-widgets">Notifications</span>
                                        {updateCount > 0 && (
                                            <span className="sidebar-notification-badge">
                                                {updateCount > 99 ? '99+' : updateCount}
                                            </span>
                                        )}
                                    </Link>
                                </li>
                            )}

                            {user?.userType === 'ADMIN' && (
                                <li className={`nav-item ${location.pathname === '/chat-support' ? 'active' : ''}`}>
                                    <Link to={'/chat-support'} className="nav-link menu-link">
                                        <MdOutlineChat />
                                        <span data-key="t-widgets">Chat Support</span>
                                    </Link>
                                </li>
                            )}

                            {/* {checkUserPermissions('view_supports') ? */}
                            {userType !== 'ADMIN' && (
                                <li className={`nav-item ${location.pathname === '/support' ? 'active' : ''}`}>
                                    <Link to={'/support'} className="nav-link menu-link" >
                                        <FiHeadphones /> <span data-key="t-widgets">Getto Helpline</span>
                                    </Link>
                                </li>
                            )}

                            {canShowInstall && (
                                <li className="nav-item">
                                    <button
                                        type="button"
                                        className="nav-link menu-link install-app-link"
                                        onClick={handleInstallApp}
                                    >
                                        <FiDownload /> <span data-key="t-widgets">Install app</span>
                                    </button>
                                </li>
                            )}



                            {checkUserPermissions('view_roles') || checkUserPermissions('view_users') ?
                                <li className="nav-item" id="sidebarUsers">
                                    <a className="nav-link menu-link" href="#sidebarUsers" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="sidebarUsers">
                                        <FiUserCheck />
                                        <span data-key="t-dashboards">User Management</span>
                                        <div className='collapse-icon'><FiChevronRight /></div>
                                    </a>
                                    <div className="collapse menu-dropdown" id="sidebarUsers">
                                        <ul className="nav nav-sm flex-column">
                                            {checkUserPermissions('view_roles') ?
                                                <li className="nav-item">
                                                    <Link to={'/roles'} className="nav-link" data-key="t-analytics">
                                                        Roles
                                                    </Link>
                                                </li>
                                                :
                                                <></>
                                            }
                                            {checkUserPermissions('view_users') ?
                                                <li className="nav-item">
                                                    <Link to={'/users'} className="nav-link" data-key="t-crm">
                                                        Users
                                                    </Link>
                                                </li>
                                                :
                                                <></>
                                            }
                                        </ul>
                                    </div>
                                </li>
                                :
                                <></>
                            }

                        </ul>
                    </div>
                </div>
            </div>
            {isVendor && (
                <Link
                    to='/billing'
                    className={`bottom_wrapper_ai ${location.pathname === '/billing' || location.pathname === '/billing/history' ? 'active' : ''}`}
                    style={SIDEBAR_STYLES.aiWrap}
                >
                    <div className='ai-widget-icon' style={SIDEBAR_STYLES.aiIcon}>
                        <FaWandMagicSparkles />
                    </div>
                    <div className='ai-widget-content'>
                        <span className='ai-widget-title' style={SIDEBAR_STYLES.aiTitle}>AI photoshoots</span>
                        <div className='ai-widget-sub' style={SIDEBAR_STYLES.aiSub}>
                            {subscriptionPlanName ? `${subscriptionPlanName} plan` : 'No active plan'}
                        </div>
                    </div>
                </Link>
            )}

            {user?.userType === 'ADMIN' ?
                <Link className={`bottom_wrapper_sidebar ${location.pathname === '/my-profile' ? 'active' : ''}`} to='/my-profile' style={SIDEBAR_STYLES.profileWrap}>
                    <div className='user_pro_wrapper'>
                        <div className='img_wrapper' style={SIDEBAR_STYLES.profileImg}>
                            <img src={logogetto} className='logo_img img-fluid' alt='Logo' />
                        </div>
                        <div className='content_wrapper'>
                            <h5 style={SIDEBAR_STYLES.profileName}>{user?.firstName}</h5>
                            <p style={SIDEBAR_STYLES.profileEmail}>{user?.email}</p>
                        </div>
                    </div>
                </Link>
                :
                <Link className={`bottom_wrapper_sidebar ${location.pathname === '/my-profile' ? 'active' : ''}`} to='/my-profile' style={SIDEBAR_STYLES.profileWrap}>
                    <div className='user_pro_wrapper'>
                        <div className='img_wrapper' style={SIDEBAR_STYLES.profileImg}>
                            <img src={store?.image ? store?.image : logogetto} className='logo_img img-fluid' alt={user?.firstName} />
                        </div>
                        <div className='content_wrapper'>
                            <h5 style={SIDEBAR_STYLES.profileName}>{user?.firstName}</h5>
                            <p style={SIDEBAR_STYLES.profileEmail}>{user?.email}</p>
                        </div>
                    </div>
                </Link>
            }
            <div className="sidebar-background" />
        </div>
        </>
    )
}

export default Sidebar